import { Icon } from '@doordash/design-language';
export var IconTypes = Icon.Types;
export var TagSizes;

(function (TagSizes) {
  TagSizes["XSmall"] = "XSmall";
  TagSizes["Small"] = "Small";
  TagSizes["Medium"] = "Medium";
  TagSizes["Large"] = "Large";
})(TagSizes || (TagSizes = {}));

export var TagTypes; // To Do (lindsey-menges):
// properly type `textProps` when Text has fleshed out
// type definitions

(function (TagTypes) {
  TagTypes["HighlightDefault"] = "HighlightDefault";
  TagTypes["HighlightEmphasis"] = "HighlightEmphasis";
  TagTypes["HighlightSubdued"] = "HighlightSubdued";
  TagTypes["InformationalDefault"] = "InformationalDefault";
  TagTypes["InformationalEmphasis"] = "InformationalEmphasis";
  TagTypes["InformationalSubdued"] = "InformationalSubdued";
  TagTypes["NegativeDefault"] = "NegativeDefault";
  TagTypes["NegativeEmphasis"] = "NegativeEmphasis";
  TagTypes["NegativeSubdued"] = "NegativeSubdued";
  TagTypes["PositiveDefault"] = "PositiveDefault";
  TagTypes["PositiveEmphasis"] = "PositiveEmphasis";
  TagTypes["PositiveSubdued"] = "PositiveSubdued";
  TagTypes["WarningDefault"] = "WarningDefault";
  TagTypes["WarningEmphasis"] = "WarningEmphasis";
  TagTypes["WarningSubdued"] = "WarningSubdued";
})(TagTypes || (TagTypes = {}));